export const openVitalSourceEbook = (wa_alias, uid, publisher_id, win_name, ebook, page) => {
  let params  = `publisher_id=${publisher_id}&id=${ebook}&name=${win_name}`;
  if (page) {
    params += `&page=${page}`;
  }
  fetch(`/web/Rest/Ebook-Vitalsource/launch?${params}`, {
    credentials: 'same-origin',
  })
  .then((response) => {
    if (response.ok) {
      return response.json();
    }
    return Promise.reject('There was an error launching your ebook');
  })
  .then((data) => {
    const url = data.result.link;
    if (url) {
      launchVitalsource(url);
      return;
    }
    vitalsourceError();

  })
  .catch((error) => {
    // tslint:disable-next-line:no-console
    console.log('error is:', error);
    vitalsourceError();
  });
};

const launchVitalsource = (url) => {
  const windowOptions = 'toolbar=no,location=no,directories=no,status=no,menubar=no,scrollbar=no,resizable,copyhistory=yes,width=961,height=720,left=25,top=25,screenX=25,screenY=25';
  const ebookWindow = window.open(url, '_blank', windowOptions);
};

const vitalsourceError = () => {
  const message = `
    <div class="modalMessage">
      There was an error launching your ebook.
    </div>
    <hr>
  `;
  // tslint:disable-next-line:no-empty
  let modal = new vitalsourceModal(message, 'n', 'Cancel', 'OK', () => {}, 'vitalsource_password', 'modal');
  modal.show();
};
